import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-fortnite',
  templateUrl: './fortnite.component.html',
  styleUrls: ['./fortnite.component.css']
})
export class FortniteComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
